/**
 * This method takes the formatted address, values as a parameter,
 * return the updated substring based on split value
 * @param {String} str - formatted string value
 * @param {string} char - after which character split needed
 * @param {Number} val - split value
 */
const addressStringFormatter = ( str, char, val ) => {
  return str?.split( char )[val];
};

export default addressStringFormatter;